"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
exports.localeStoreManager = new skynet_store_manager_1.EntityStoreManager('locales.data', function (item) { return item.languageId; });
//# sourceMappingURL=locales.store.js.map